import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { AppShell } from './components/AppShell';
import { AdminDashboardPage } from './pages/AdminDashboardPage';
import { CameraSetupPage } from './pages/CameraSetupPage';
import { FinishedPage } from './pages/FinishedPage';
import { InstructionsPage } from './pages/InstructionsPage';
import { LandingPage } from './pages/LandingPage';
import { LoginPage } from './pages/LoginPage';
import { MockExamPage } from './pages/MockExamPage';
import { PermissionCheckPage } from './pages/PermissionCheckPage';
import { PhonePairingPage } from './pages/PhonePairingPage';
import { ProctorDashboardPage } from './pages/ProctorDashboardPage';
import { ReportPage } from './pages/ReportPage';
import { CandidateWorkflowRoute, CompletedCandidateRoute, ProtectedRoute } from './components/ProtectedRoute';
import { useExam } from './context/ExamContext';

export function App() {
  const location = useLocation();
  const { state } = useExam();
  const fullScreenExam = location.pathname === '/exam' || (
    state.candidate?.role === 'candidate' && Boolean(state.startedAt) && !state.finishedAt
  );

  const routes = (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/instructions" element={<CandidateWorkflowRoute><InstructionsPage /></CandidateWorkflowRoute>} />
      <Route path="/permissions" element={<CandidateWorkflowRoute required="instructionsAcknowledged"><PermissionCheckPage /></CandidateWorkflowRoute>} />
      <Route path="/camera-setup" element={<CandidateWorkflowRoute required="permissionsCompleted"><CameraSetupPage /></CandidateWorkflowRoute>} />
      <Route path="/phone-pairing" element={<PhonePairingPage />} />
      <Route path="/exam" element={<CandidateWorkflowRoute required="cameraSetupCompleted"><MockExamPage /></CandidateWorkflowRoute>} />
      <Route path="/proctor-dashboard" element={<ProtectedRoute roles={['reviewer', 'admin']}><ProctorDashboardPage /></ProtectedRoute>} />
      <Route path="/finished" element={<CompletedCandidateRoute><FinishedPage /></CompletedCandidateRoute>} />
      <Route path="/report" element={<ProtectedRoute roles={['reviewer', 'admin']}><ReportPage /></ProtectedRoute>} />
      <Route path="/admin" element={<ProtectedRoute roles={['admin']}><AdminDashboardPage /></ProtectedRoute>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );

  return fullScreenExam ? routes : <AppShell>{routes}</AppShell>;
}
